import About from './About';

function AboutHome() {
  return (
    <section id="about" className="dog-bg2">
      <div className="container">
        <div className="section-heading text-center">
          <h2>PawFriends Sarajevo</h2>
        </div>
      <About />
      </div>
    </section>
  );
}
export default AboutHome;
